import IList from '@/types/components/IList.interface'
import Vue from 'vue'

interface State {
    iLists: Object
}

const defaults = () => {
    return {
        iLists: {}
    }
}
export default {
    state: defaults(),
    mutations: {
        iListSet(state: State, list: IList): void {

            const exists = state.iLists[list.id]

            if (exists) return

            Vue.set(state.iLists, list.id, list)
        }
    },
    actions: {},
    getters: {
        iList: (state: State) => (id: string): IList => {
            const iList = state.iLists[id]
            return iList
        }
    }
}
